<template>
  <div class="authentication">
    <div class="state-box" v-if="!notSubmitted">
      <div v-if="companyDetailData.auditStatus == 0 && pageType == 'new'" class="warning-tool">
        审核中，请耐心等待
      </div>
      <div v-if="companyDetailData.auditStatus == 2 && pageType == 'new'" class="danger-tool">
        审核拒绝，原因：{{ companyDetailData.auditReason }}
      </div>
      <span v-if="pageType == 'old'">{{ companyDetailData.auditStatus | auditStatusFileter }}</span>
    </div>
    <el-form ref="form" :model="formData" :rules="rules" label-width="40px">
      <div class="group">
        <div class="top">
          <div class="lines">
            <el-form-item label-width="80px" label="企业类型" prop="companyTypes">
              <el-checkbox-group
                v-model="formData.companyTypes"
                :disabled="!notSubmitted"
                @change="companyTypesChange">
                <el-checkbox v-for="item in firmtypeList" :label="item.dictId" :key="item.dictId">{{
                  item.dictValue
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <div class="upload-box">
            <el-form-item prop="idcardBackUrl" label-width="0">
              <MyUpLoad
                v-model="formData.idcardBackUrl"
                name="上传法人身份证人像面"
                type="2"
                validate="idcardBackUrl"
                @ocrIdcardCertificate="changeIdcard"
                :disabled="!disabled" />
            </el-form-item>
            <el-form-item prop="idcardFrontUrl" label-width="0">
              <MyUpLoad
                v-model="formData.idcardFrontUrl"
                name="上传法人身份证国徽面"
                type="1"
                @idcardCertificate="changeIdcards"
                validate="idcardFrontUrl"
                :disabled="!disabled" />
            </el-form-item>
            <el-form-item prop="businessLicenseUrl" label-width="0">
              <MyUpLoad
                v-model="formData.businessLicenseUrl"
                type="3"
                name="上传营业执照"
                validate="businessLicenseUrl"
                @tradingCertificate="changeTrading"
                :popVisible="!notSubmitted && disabled"
                :disabled="!disabled" />
            </el-form-item>
          </div>
          <div>
            <el-form-item prop="roadTransportLicenseUrl" label-width="0">
              <MyUpLoad
                v-show="isRoadTransportLicense"
                v-model="formData.roadTransportLicenseUrl"
                name="上传运输许可证"
                validate="roadTransportLicenseUrl"
                :disabled="!notSubmitted" />
            </el-form-item>
          </div>
          <!-- <div class="entrust">
            <div class="top">
              <p>委托书模板</p>
              <span>预览</span>
              <span>|</span>
              <span class="download">下载</span>
            </div>
            <el-form-item prop="attorneyPowerUrl" label-width="0">
              <el-upload
                action=""
                :before-upload="beforeUpload"
                v-if="!formData.attorneyPowerUrl || !disabled"
              >
                <el-button size="small" type="primary" class="hy-btn"
                  >点击上传委托书</el-button
                >
              </el-upload>
              <div v-if="formData.attorneyPowerUrl && notSubmitted">
                <span>{{ attorneyPowerName }}</span>
                <span @click="formData.attorneyPowerUrl = ''" class="remove"
                  ><i class="el-icon-delete"></i
                ></span>
              </div>
            </el-form-item>
          </div> -->
        </div>
      </div>
      <div class="title">认证信息</div>
      <div class="group">
        <div class="line">
          <el-form-item label=" " prop="companyName">
            <el-input
              v-model.trim="formData.companyName"
              placeholder="请输入企业名称"
              maxlength="64"
              prefix-icon="hy-icon-yinhang"
              :disabled="!notSubmitted"></el-input>
            <el-popover
              v-if="!notSubmitted && disabled"
              placement="right"
              trigger="hover"
              width="150"
              class="popover-box">
              <div class="custom-content">修改企业名称，请联系客服人员：<br />0902-2305929</div>
              <i slot="reference" class="el-icon-warning-outline" style="font-size: 14px"></i>
            </el-popover>
          </el-form-item>
          <el-form-item label=" " prop="legalName">
            <el-input
              v-model.trim="formData.legalName"
              placeholder="请输入法人名称"
              maxlength="20"
              prefix-icon="hy-icon-shenfenzheng"
              :disabled="!disabled"></el-input>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label=" " prop="legalIdcard">
            <el-input
              v-model="formData.legalIdcard"
              placeholder="请输入法人身份证号"
              prefix-icon="hy-icon-shenfenzheng"
              maxlength="18"
              :disabled="!disabled"></el-input>
          </el-form-item>
          <el-form-item label=" " prop="socialCode">
            <el-input
              v-model="formData.socialCode"
              placeholder="请输入统一信用代码"
              prefix-icon="hy-icon-yinhang"
              maxlength="30"
              :disabled="!notSubmitted"></el-input>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label=" " prop="idcardValidityTerm" style="position: relative">
            <span style="position: absolute; left: -21px; top: 3px; color: red">*</span>
            <el-date-picker
              class="date-pick"
              v-model="formData.idcardValidityTerm"
              type="daterange"
              value-format="yyyy.MM.dd"
              range-separator="至"
              start-placeholder="身份证有效期"
              end-placeholder="结束日期"
              :disabled="!disabled || formData.ifLong">
            </el-date-picker>
            <el-form-item label=" " prop="ifLong" class="item-if-long">
              <el-checkbox
                v-model="formData.ifLong"
                :disabled="!disabled || formData.idcardValidityTerm != null"
                >长期</el-checkbox
              >
            </el-form-item>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label=" " prop="region">
            <span style="position: absolute; left: -21px; top: 3px; color: red">*</span>
            <el-cascader
              v-model="formData.region"
              :options="citys"
              placeholder="请选择省/市/区"
              filterable
              :props="{
                value: 'name',
                label: 'name',
              }"
              :disabled="!notSubmitted"></el-cascader>
          </el-form-item>
          <el-form-item label=" " prop="address" class="address-input">
            <el-input
              v-model.trim="formData.address"
              prefix-icon="el-icon-location-information"
              maxlength="100"
              placeholder="请输入详细地址"
              :disabled="!notSubmitted"></el-input>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label=" " prop="email">
            <el-input
              v-model.trim="formData.email"
              placeholder="请输入电子邮箱"
              prefix-icon="el-icon-message"
              maxlength="30"
              :disabled="!notSubmitted"></el-input>
          </el-form-item>
        </div>

        <!-- <div class="line">
          <el-form-item label-width="80px" label="企业类型" prop="companyTypes">
            <el-checkbox-group
              v-model="formData.companyTypes"
              :disabled="!notSubmitted"
            >
              <el-checkbox
                v-for="item in firmtypeList"
                :label="item.dictId"
                :key="item.dictId"
                >{{ item.dictValue }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </div> -->
      </div>
      <div class="title">收款账户信息<span>（请填写后核实,账号为您的线下收款账号）</span></div>
      <div class="group">
        <div class="line">
          <el-form-item label=" " prop="accountNumber">
            <el-input
              v-model.trim="formData.accountNumber"
              placeholder="请输入收款账号"
              maxlength="30"
              prefix-icon="hy-icon-yinhangka"
              @change="formDataaCcountNumber"
              oninput="value=value.replace(/[^\d]/g,'')"
              :disabled="!disabled"></el-input>
          </el-form-item>
          <el-form-item label=" " prop="accountName">
            <el-input
              v-model.trim="formData.accountName"
              placeholder="请输入收款户名"
              prefix-icon="hy-icon-yonghuming"
              maxlength="30"
              :disabled="!disabled"></el-input>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label=" " prop="accountBank">
            <!-- <el-input
              v-model.trim="formData.accountBank"
              placeholder="请输入收款银行名称"
              maxlength="20"
              :disabled="!disabled"
              prefix-icon="hy-icon-yinhang"
            ></el-input> -->
            <!-- 远程搜索要使用filterable和remote -->
            <el-select
              v-model.trim="formData.accountBank"
              filterable
              remote
              placeholder="请选择或输入银行名称"
              :remote-method="remoteMethod"
              :loading="loading"
              :disabled="!disabled"
              clearable>
              <!-- remote-method封装好的钩子函数。当用户在输入框中输入内容的时候，会触发这个函数的执行，
   把输入框对应的值作为参数带给回调函数，loading的意思就是远程搜索的时候等待的时间，即：加载中-->
              <el-option
                v-for="item in options"
                :key="item.dictValue"
                :label="item.dictValue"
                :value="item.dictValue">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="title">经办人信息</div>
      <div class="group">
        <div class="line">
          <el-form-item label="是否为法人本人" prop="handlerLegalFlag" label-width="150px">
            <el-radio-group
              v-model="formData.handlerLegalFlag"
              :disabled="!disabled"
              @change="handlerLegalFlagChange">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div v-if="formData.handlerLegalFlag === 0">
          <div class="upload-box padding-content">
            <el-form-item prop="handlerIdcardFrontUrl" label-width="0">
              <MyUpLoad
                v-model="formData.handlerIdcardFrontUrl"
                name="上传经办人身份证人像面"
                type="2"
                validate="handlerIdcardFrontUrl"
                @ocrIdcardCertificate="changehandlerIdcard"
                :disabled="!disabled" />
            </el-form-item>
            <el-form-item prop="handlerIdcardBackUrl" label-width="0">
              <MyUpLoad
                v-model="formData.handlerIdcardBackUrl"
                name="上传经办人身份证国徽面"
                type="1"
                validate="handlerIdcardBackUrl"
                :disabled="!disabled" />
            </el-form-item>
          </div>
          <div class="line">
            <el-form-item label=" " prop="handlerName">
              <el-input
                v-model="formData.handlerName"
                placeholder="请输入经办人姓名"
                prefix-icon="hy-icon-yonghuming"
                maxlength="20"
                :disabled="!disabled"></el-input>
            </el-form-item>
            <el-form-item label=" " prop="handlerIdcard">
              <el-input
                v-model="formData.handlerIdcard"
                placeholder="请输入经办人身份证号"
                prefix-icon="hy-icon-shenfenzheng"
                maxlength="18"
                :disabled="!disabled"></el-input>
            </el-form-item>
          </div>
          <div class="upload-box padding-content">
            <el-form-item prop="handlerLetterAuthorization" label-width="0">
              <MyUpLoad
                v-model="formData.handlerLetterAuthorization"
                name="上传经办人授权书"
                type=""
                validate="handlerLetterAuthorization"
                :disabled="!disabled" />
              <div class="author-download" v-if="disabled">
                授权书模板
                <el-button type="text" @click="handleAuthorizationDownload">下载</el-button>
              </div>
            </el-form-item>
          </div>
        </div>
        <div v-if="formData.handlerLegalFlag == 1">
          <div class="upload-box padding-content">
            <el-form-item prop="handlerLegalPhotoUrl" label-width="0">
              <MyUpLoad
                v-model="formData.handlerLegalPhotoUrl"
                name="上传法人手持身份证照片"
                type=""
                validate="handlerLegalPhotoUrl"
                :disabled="!disabled" />
              <div class="author-download" v-if="disabled">
                <el-button type="text" @click="handleLegalPersonIdCard">示例</el-button>
              </div>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="bottom" v-if="notSubmitted">
        <div class="checked">
          <el-checkbox v-model="radio" :label="true">&nbsp;</el-checkbox>
          <p>
            已阅读并同意<span @click="user = true" class="agreement"
              >《新疆煤炭交易中心交易商认证协议》</span
            >
          </p>
        </div>
        <div class="btn-wrap">
          <el-button @click="submit" class="hy-btn" :disabled="!radio" :loading="submiting"
            >提交认证</el-button
          >
        </div>
        <div class="tip">认证成功后,当前申请账号将自动成为企业管理员账号！</div>
      </div>
      <div v-else>
        <!-- <div class="bottom" v-if="formData.auditStatus == 0">
          <div class="tip">审核通过后才可修改收款账号</div>
        </div> -->
        <div
          class="bottom"
          v-if="
            userId == formData.enterpriseId &&
            (formData.auditStatus == 1 || formData.auditStatus == 2)
          ">
          <div class="btn-wrap" v-if="!disabled">
            <!-- 当前已存在未审核通过的申请，不允许修改 -->
            <el-button
              @click="edit"
              v-if="formData.auditStatus == 1 && lastApplyStatus !== 0 && lastApplyStatus !== 2"
              >修改账户信息</el-button
            >
            <el-button v-if="formData.auditStatus == 2" @click="recertification"
              >重新认证</el-button
            >
          </div>
          <div class="btn-wrap" v-else>
            <el-button @click="submitedit" :loading="submiting">确认修改</el-button>
          </div>
        </div>
      </div>
    </el-form>
    <EnterpriseAgreementDlg :visible.sync="user" />
    <message :visible.sync="mssagevisible" />
    <!-- 图片预览 -->
    <PreviewImage ref="previewImageRef" :isLocal="true" />
  </div>
</template>

<script>
// function insertStr(soure, start, newStr) {
//   return soure.slice(0, start) + newStr + soure.slice(start);
// }
import { getbannerList } from "@/api/home";
import {
  reqCompanyAuthDetail,
  reqApplyCompanyAuthDetail,
  reqAddAuth,
  reqEditAuthCompany,
  getSysDictDataByByDictType,
  // reqUploadfile,
  systemSysList,
} from "@/api/hy";
import { getCompanyAuthDetail } from "@/api/userCenters.js";
import url from "@/api/url/hy_url";
import Vue from "vue";
import * as types from "@/store/action-types";
import { downFile } from "@/utils/toolset.js";
import { getTreeV2 } from "@/api/Medium.js";
const { baseUrl } = require("@/config");

export default {
  data() {
    const validateLegerName = (rule, value, callback) => {
      let validate = /^[\u4e00-\u9fa5·]{2,20}$/;
      if (!validate.test(value)) {
        return callback(new Error("请输入2-20位汉字"));
      } else {
        return callback();
      }
    };
    const validateRegion = (rule, value, callback) => {
      if (value?.length > 0) {
        return callback();
      } else {
        /** 修改的时候不校验 */
        if (this.disabled) {
          return callback();
        } else {
          return callback(new Error("请选择省/市/区"));
        }
      }
    };
    return {
      baseUrl: baseUrl,
      fileBaseUrl: baseUrl + url.getFileUrl,
      citys: [],
      mssagevisible: false,
      firmtypeList: [],
      //模糊搜索
      options: [],
      loading: false,
      //
      userId: Vue.ls.get(types.userId),
      formData: {
        enterpriseId: Vue.ls.get(types.enterpriseId),
        idcardFrontUrl: "",
        idcardBackUrl: "",
        businessLicenseUrl: "",
        roadTransportLicenseUrl: "",
        legalName: "",
        companyName: "",
        legalIdcard: "",
        socialCode: "",
        idcardValidityTerm: null,
        accountNumber: "",
        accountName: "",
        accountBank: "",
        // attorneyPowerUrl: "",
        auditStatus: null,
        ifLong: false,
        companyTypes: [],
        /** 省市区 */
        region: [],
        /** 详细地址 */
        address: "",
        /** 经办人身份证人像面 */
        handlerIdcardFrontUrl: "",
        /** 经办人身份证国徽面 */
        handlerIdcardBackUrl: "",
        /** 经办人姓名 */
        handlerName: "",
        /** 经办人身份证号 */
        handlerIdcard: "",
        /** 经办人授权书地址 */
        handlerLetterAuthorization: "",
        /** 是否法人本人 0否 1是 */
        handlerLegalFlag: 0,
        /** 法人手持身份证照片 */
        handlerLegalPhotoUrl: "",
      },
      rules: {
        legalName: [
          { required: true, message: "请输入法人名称", trigger: ["blur", "change"] },
          { validator: validateLegerName, trigger: "blur" },
        ],
        idcardFrontUrl: [
          {
            required: true,
            message: "请上传法人身份证国徽面",
            trigger: "change",
          },
        ],
        region: [{ validator: validateRegion, trigger: "blur" }],
        email: [
          {
            required: true,
            message: "请输入电子邮箱",
            trigger: ["blur", "change"],
          },
        ],
        idcardBackUrl: [
          {
            required: true,
            message: "请上传法人身份证人像面",
            trigger: "change",
          },
        ],
        businessLicenseUrl: [{ required: true, message: "请上传营业执照", trigger: "change" }],
        companyName: [
          { required: true, message: "请填写企业名称", trigger: ["blur", "change"] },
          {
            min: 1,
            max: 99,
            message: "长度在 1 到 99 个字符",
            trigger: "blur",
          },
        ],
        legalIdcard: [
          { required: true, message: "请填写法人身份证号", trigger: ["blur", "change"] },

          {
            pattern:
              /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/,
            message: "请输入有效身份证号码",
            trigger: "blur",
          },
        ],
        socialCode: [
          { required: true, message: "请填写统一信用代码", trigger: ["blur", "change"] },
          {
            pattern: /^[A-Za-z0-9]{1,30}$/,
            message: "请输入有效统一信用代码",
            trigger: "blur",
          },
          { min: 1, max: 30, trigger: "blur" },
        ],

        accountNumber: [
          { required: false, message: "请填写收款账号", trigger: ["blur", "change"] },
          {
            pattern: /^[0-9]{1,30}/,
            message: "请输入有效收款账号",
            trigger: "blur",
          },
          { min: 1, max: 30, trigger: "blur" },
        ],
        accountName: [
          { required: false, message: "请填写收款户名", trigger: ["blur", "change"] },
          {
            pattern: /^[\u4E00-\u9FA5]{1,30}$/,
            message: "请输入正确收款户名",
            trigger: "blur",
          },
          { min: 1, max: 30, trigger: "blur" },
        ],
        accountBank: [{ required: false, message: "请填写收款银行", trigger: ["blur", "change"] }],
        // attorneyPowerUrl: [{ required: true, message: "请上传委托书", trigger: "change" }],
        companyTypes: [{ required: true, message: "请选择企业类型", trigger: "change" }],
        address: [{ required: true, message: "请填写住所详细地址", trigger: ["blur", "change"] }],
        handlerIdcardFrontUrl: [
          {
            required: true,
            message: "请上传经办人身份证人像面",
            trigger: "change",
          },
        ],
        handlerIdcardBackUrl: [
          {
            required: true,
            message: "请上传经办人身份证国徽面",
            trigger: "change",
          },
        ],
        handlerName: [
          { required: true, message: "请填写经办人姓名", trigger: "blur" },
          { validator: validateLegerName, trigger: "blur" },
        ],
        handlerIdcard: [
          { required: true, message: "请填写经办人身份证号", trigger: "blur" },
          {
            pattern:
              /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/,
            message: "请输入有效身份证号码",
            trigger: "blur",
          },
        ],
        handlerLetterAuthorization: [
          { required: true, message: "请上传经办人授权书", trigger: "change" },
        ],
        handlerLegalFlag: [
          { required: true, message: "请选择是否为法人本人经办", trigger: "blur" },
        ],
        handlerLegalPhotoUrl: [
          { required: true, message: "请上传法人手持身份证照片", trigger: "change" },
        ],
      },
      /** 企业认证协议勾选状态 */
      radio: false,
      // attorneyPowerName: "",
      /** 提交按钮状态 */
      submiting: false,
      /** 是否为未提交认证  且  不能再次修改的企业信息 */
      notSubmitted: false,
      /** 是否为未提交认证  且  可以进行修改的企业信息 */
      disabled: false,
      /** 查看企业认证协议弹窗开关 */
      user: false,
      /** 是否是修改后重新认证 */
      isagin: false,
      /** 是否显示道路运输经营许可证上传字段 */
      isRoadTransportLicense: false,
      /** 初始企业详情数据 */
      companyDetailData: {},
      /** 页面类型 old 首次或已认证通过信息 new 最新提交未审核通过的信息  */
      pageType: "old",
      /** 最后一次更新状态 */
      lastApplyStatus: "",
    };
  },
  filters: {
    auditStatusFileter(val) {
      return {
        "-1": "未提交认证",
        0: "审核中",
        1: "已通过",
        2: "已拒绝",
      }[val];
    },
  },
  // computed: {
  //   /** 控制省市区是否禁用 */
  //   isRegionDisabled() {
  //     /** 未提交认证 */
  //     if (this.companyDetailData.auditStatus == -1) return false;
  //     /** 修改账户信息或需要重新认证 */
  //     if (this.disabled) {
  //       console.log("companyDetailData.region", this.companyDetailData.region);
  //       if (this.companyDetailData.region) return true;
  //       else return false;
  //     } else {
  //       return true;
  //     }
  //   },
  // },
  components: {
    MyUpLoad: () => import("./components/MyUpLoad.vue"),
    message: () => import("./components/message.vue"),
    PreviewImage: () => import("@/components/PreviewImg.vue"),
    EnterpriseAgreementDlg: () => import("./components/EnterpriseAgreementDlg.vue"),
  },
  mounted() {
    this.pageType = this.$route.query?.type || "old";
    this.getTree();
    this.getCompanyDetail();
    this.handleSelect();
  },
  methods: {
    /** 是否法人本人切换按钮 */
    handlerLegalFlagChange(value) {
      if (value == 1) {
        this.formData.handlerIdcardFrontUrl = "";
        this.formData.handlerIdcardBackUrl = "";
        this.formData.handlerName = "";
        this.formData.handlerIdcard = "";
        this.formData.handlerLetterAuthorization = "";
      } else {
        this.formData.handlerLegalPhotoUrl = "";
      }
    },
    /** 查看法人手持身份证示例图片 */
    handleLegalPersonIdCard() {
      this.$refs.previewImageRef.open("sample.png");
    },
    /** 授权书模板下载 */
    handleAuthorizationDownload() {
      let dictType = "authorization_letter";
      systemSysList(dictType).then(res => {
        if (res.code == 0) {
          downFile(this.fileBaseUrl + res.data[0].dictValue, res.data[0].dictLabel);
        }
      });
    },
    getTree() {
      getTreeV2().then(res => {
        if (res.code == 0) {
          this.citys = this.deleteChildren(res.data);
        }
      });
    },
    deleteChildren(arr) {
      let childs = arr;
      for (let i = childs.length; i--; i > 0) {
        if (childs[i].children) {
          if (childs[i].children.length) {
            this.deleteChildren(childs[i].children);
          } else {
            delete childs[i].children;
          }
        }
      }
      return arr;
    },
    companyTypesChange(e) {
      console.log(e);
      let list = e;
      if (list.length > 0) {
        if (list.includes("408")) {
          this.isRoadTransportLicense = true;
        } else {
          this.isRoadTransportLicense = false;
        }
      } else {
        this.isRoadTransportLicense = false;
      }
    },
    async getFirmtype() {
      const obj = {
        pageNum: 1,
        pageSize: 1000,
        dictType: "company_type",
      };
      const res = await getbannerList(obj);
      if (res.code == 0) {
        if (!this.notSubmitted && this.formData.auditStatus == 1) {
          let newlist = [];
          this.formData.companyTypes.map(item => {
            res.data.list.map(it => {
              if (item == it.dictId) {
                this.firmtypeList.push(it);
                newlist.push(it.dictId);
              }
            });
          });

          if (newlist.length > 0) {
            if (newlist.includes("408")) {
              this.isRoadTransportLicense = true;
            } else {
              this.isRoadTransportLicense = false;
            }
          } else {
            this.isRoadTransportLicense = false;
          }
        } else {
          this.firmtypeList = res.data.list;
        }
      }
    },
    /** 识别营业执照信息 */
    changeTrading(data) {
      /** 只有首次认证时才能更改表单信息 */
      if (this.companyDetailData.auditStatus != -1) return;
      this.formData.address = data.address;
      this.formData.companyName = data.name;
      this.formData.legalName = data.owner;
      this.formData.socialCode = data.code;
    },
    changeIdcards(data) {
      let arr = data?.timelimit?.split("-") || null;
      this.formData.idcardValidityTerm = arr;
    },
    /** 识别法人身份证正面图片信息 */
    changeIdcard(data) {
      this.formData.legalIdcard = data.number;
      this.formData.legalName = data.name;
    },
    /** 识别经办人身份证正面图片信息 */
    changehandlerIdcard(data) {
      this.formData.handlerName = data.name;
      this.formData.handlerIdcard = data.number;
    },
    // 当用户输入内容开始远程搜索模糊查询的时候，会触发remoteMethod方法
    remoteMethod(query) {
      // 如果用户输入内容了，就发请求拿数据，远程搜索模糊查询
      if (query !== "") {
        this.loading = true; // 开始拿数据喽
        // 这里模拟发请求，res就当成发请求返回来的数据吧。
        let config = {
          dictType: "bank_name",
          pageNum: 1,
          pageSize: 10000000,
          searchParam: query,
        };
        getSysDictDataByByDictType(config).then(ret => {
          if (ret.code == 0) {
            let res = ret.data.list;
            console.log(res);
            this.loading = false; //
            // 然后把拿到的所有数据，首先进行一个过滤，把有关联的过滤成一个新数组给到options使用
            this.options = res.filter(item => {
              // indexOf等于0代表只要首个字匹配的，如：搜索 王 王小虎数据会被过滤出来，但是 小虎王的数据不会被过滤出来。因为indexOf等于0代表以什么开头
              // return item.label.toLowerCase().indexOf(query.toLowerCase()) == 0

              // indexOf大于-1代表的是，只要有这个字出现的即可，如：搜索 王 王小虎、小虎王、小王虎都会被过滤出来。因为indexOf找不到才会返回-1，
              // 大于-1说明只要有就行，不论是不是开头也好，中间也好，或者结尾也好
              return item.dictValue.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
          }
        });
      } else {
        this.options = [];
      }
    },

    handleSelect(e) {
      let config = {
        dictType: "bank_name",
        pageNum: 1,
        pageSize: 10000000,
        searchParam: e ? e : "",
      };
      getSysDictDataByByDictType(config).then(res => {
        if (res.code == 0) {
          this.options = res.data.list;
        }
      });
    },
    formDataaCcountNumber(e) {
      this.formData.accountNumber = e;
    },
    /** 重新认证按钮 */
    recertification() {
      // this.formData.auditStatus=0
      this.disabled = true;
      if (
        this.companyDetailData.handlerLegalFlag !== 0 &&
        this.companyDetailData.handlerLegalFlag !== 1
      ) {
        this.formData.handlerLegalFlag = 0;
      } else {
        this.formData.handlerLegalFlag = this.companyDetailData.handlerLegalFlag;
      }
      if (this.pageType == "new") {
        this.isagin = true;
        this.notSubmitted = false;
      } else {
        this.notSubmitted = true;
      }
    },
    /** 修改按钮 */
    edit() {
      // this.formData.auditStatus=0
      this.disabled = true;
      if (
        this.companyDetailData.handlerLegalFlag !== 0 &&
        this.companyDetailData.handlerLegalFlag !== 1
      ) {
        this.formData.handlerLegalFlag = 0;
      }
    },
    /** 获取企业认证信息 */
    async getCompanyDetail() {
      let ret;
      let enterpriseId = Vue.ls.get(types.enterpriseId);
      if (this.pageType == "new") {
        ret = await reqApplyCompanyAuthDetail({ enterpriseId });
      } else {
        ret = await reqCompanyAuthDetail({ enterpriseId });
      }
      if (ret.code == 0) {
        this.isagin = false;
        this.notSubmitted = false;
        this.companyDetailData = JSON.parse(JSON.stringify(ret.data));
        /** auditStatus:审核状态(-1:未提交认证,0:待审核,1:审核通过,2:审核拒绝) */
        if (ret.data.auditStatus == -1) {
          this.notSubmitted = true;
          this.disabled = true;
        } else {
          if (ret.data.auditStatus == 1) {
            this.getCompanyAuthDetail();
          }
          this.bindData(ret.data);
          this.setDisabled(ret.data);
          if (ret.data.auditStatus == 2) {
            this.recertification();
          }
        }
      } else {
        this.notSubmitted = true;
      }
      this.getFirmtype();
    },
    /** 获取最新审核状态 */
    getCompanyAuthDetail() {
      getCompanyAuthDetail().then(res => {
        if (res.code == 0) {
          this.lastApplyStatus = res.data.lastApplyStatus;
          console.log("lastApplyStatus", this.lastApplyStatus);
          // if (this.lastApplyStatus == 2) {
          //   this.disabled = true;
          // }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    setDisabled(item) {
      /** 审核状态为未提交认证时，disabled为true */
      this.disabled = item.auditStatus != 1;
      if (item.auditStatus == 0) {
        this.disabled = false;
      }
      if (item.auditStatus == 2) {
        this.disabled = false;
      }
    },
    bindData(data) {
      this.formData = data;
      this.formData.region = data.region?.split(",");
      // console.log("getCompanyDetail", this.formData);
      if (data.idcardValidityTerm != null && data.idcardValidityTerm != "") {
        try {
          this.formData.idcardValidityTerm = data.idcardValidityTerm.split("-");
        } catch (e) {
          console.log(e);
        }
      } else {
        this.formData.idcardValidityTerm = null;
      }
      // console.log("getCompanyDetail", this.formData);
    },
    submit() {
      // if (!this.companyDetailData.region) return this.message.error("请选择省市区");
      if (!this.isEdit && !this.radio) return;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitFn();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /** 修改企业认证信息 */
    submitedit() {
      // if (!this.companyDetailData.region) {
      //   this.$refs.form.clearValidate("region");
      // }
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.submiting = true;
          let data = this.initSubmitData();
          try {
            /** 修改企业认证信息 */
            let res = await reqEditAuthCompany(data);
            if (res.code == 0) {
              this.mssagevisible = true;
              this.disabled = !this.disabled;
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
            this.submiting = false;
          } catch (err) {
            console.log(err);
            this.submiting = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    initSubmitData() {
      // this.formData.auditStatus = 0;
      let data = {
        ...this.formData,
        region: this.formData.region?.join(","),
      };
      if (data.idcardValidityTerm != null && data.idcardValidityTerm != "") {
        try {
          data.idcardValidityTerm = data.idcardValidityTerm.join("-");
        } catch (e) {
          e;
        }
      } else {
        data.idcardValidityTerm = null;
      }
      return data;
    },
    /** 提交认证 */
    submitFn() {
      if (this.submiting) return;
      this.submiting = true;
      let data = this.initSubmitData();
      data.companyName = data.companyName?.replace(/\(/g, "（").replace(/\)/g, "）");
      reqAddAuth(data)
        .then(ret => {
          if (ret.code == 0) {
            this.mssagevisible = true;
            setTimeout(() => {
              this.$router.push({
                path: "/index",
              });
            }, 3000);
          } else {
            this.$message({
              type: "error",
              message: ret.message,
            });
          }
          this.submiting = false;
        })
        .catch(err => {
          console.log(err);
          this.submiting = false;
        });
    },
    // beforeUpload(file) {
    //   this.attorneyPowerName = file.name;
    //   reqUploadfile(file)
    //     .then(ret => {
    //       if (ret.code == 0) {
    //         this.formData.attorneyPowerUrl = ret.data;
    //       }
    //     })
    //     // eslint-disable-next-line no-unused-vars
    //     .catch(err => {});
    //   return false;
    // },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__error {
  min-width: 800px;
}
.el-range-separator {
  border: 1px solid blue;
}
.authentication {
  width: 1195px;
  margin: 15px auto;
  background: white;
  &::before,
  &::after {
    display: table;
    content: "";
  }
}
.state-box {
  margin: 20px;
  .warning-tool {
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    background-color: rgba(230, 162, 60, 0.1);
    border: 1px solid #e6a23c;
    color: #e6a23c;
  }
  .danger-tool {
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    background-color: rgba(255, 0, 0, 0.1);
    border: 1px solid red;
    color: red;
  }
  span {
    text-align: right;
    display: block;
    // color: green;
  }
}
.entrust {
  .top {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    p {
      margin-right: 40px;
      color: #2084d6;
    }
    span {
      cursor: pointer;
      & + span {
        margin-left: 5px;
      }
    }
  }
}
.title {
  font-size: 18px;
  font-weight: bold;
  font-family: PingFang SC;
  padding: 14px 15px;
  border: 1px solid #e5e5e5;
  border-left: none;
  border-right: none;
  background: #f7f7f7;
  display: flex;
  align-items: center;
  span {
    margin-left: 5px;
    color: red;
    font-weight: normal;
  }
}
.upload-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.padding-content {
  padding: 0 140px;
}
.bottom {
  text-align: center;
  margin-bottom: 40px;
  .checked {
    display: flex;
    align-items: center;
    justify-content: center;
    &::v-deep .el-radio {
      margin-right: 0;
    }
  }
  .btn-wrap {
    margin: 25px 0 18px 0;
    .el-button {
      width: 200px;
    }
  }
  .tip {
    color: red;
  }
}
.remove {
  cursor: pointer;
  margin-left: 10px;
  vertical-align: middle;
}
.group {
  padding: 32px;
  background: white;
}
.line {
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 80px;

  ::v-deep .el-input,
  .el-date-editor {
    width: 360px !important;
  }

  .item-if-long {
    position: absolute;
    top: 0;
    right: -90px;
  }
}
.entrust {
  margin-left: 104px;
  .hy-btn {
    width: 163px;
  }
}
.download,
.agreement {
  cursor: pointer;
  color: #3889fb;
}
.lines {
  display: flex;
  justify-content: space-between;
}
.author-download {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 10px);
}
.popover-box {
  margin-left: 5px;
  .el-icon-warning-outline {
    font-size: 18px !important;
    color: #7b7575;
  }
}
</style>
